exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-source-forms-questions-answer-set-viewer-style__buttonIcon a.cps-link .cps-icon {\n  color: var(--cps-color-af) !important;\n}\n\n.src-source-forms-questions-answer-set-viewer-style__noButtonIcon {\n  width: 12px;\n  margin-right: 4px;\n}\n", ""]);

// exports
exports.locals = {
	"buttonIcon": "src-source-forms-questions-answer-set-viewer-style__buttonIcon",
	"noButtonIcon": "src-source-forms-questions-answer-set-viewer-style__noButtonIcon"
};